import styles from './IbpConfigurator.styl'
import Image from "./ui/features/Image.jsx";
import React, {useState} from "react";
import Table from "./ui/features/Table.jsx";
import Input from "./ui/features/Input/Input.jsx";
import DropDown from "./ui/features/DropDown/DropDown.jsx";
import CheckBoxWithHeader from "./ui/features/CheckBoxWithHeader/CheckBoxWithHeader.jsx";
import Button from "./ui/button/Button.jsx";
import jQuery from "jquery";
import {capitalizeFirstLetter, delDuplicatesFromArray} from "./Helpers/Helpers.js";
import Popup from "./ui/features/Popup/Popup.jsx";
import Modal from "./ui/features/IbpModal/IbpModal.jsx";

const IBP_TYPE_STYLE = 'ibp_tab'

const ONE_PHASE = 'Одна'
const TWO_PHASE = 'Мультифазный'
const TREE_PHASE = 'Три'
const FLOUR = 'Напольный'
const STAND = 'Стоечный'

const DD_DEFAULT = 'Выбрать'

const IBP_SIZE = {
	height: '210px',
	top: '500px'
}

const tabState = {
	tabType: IBP_TYPE_STYLE
}

const defaultIbpState = {
	minPower: '',
	maxPower: '',
	phaseNumber: DD_DEFAULT,
	mountType: DD_DEFAULT,
	double: true,
	line: true,
	transform: false,
	akbPres: false,
	snmp: false,
	useTime: false,
	module: false,
	time: 0,
}

const defaultIbpOptionsState = {
	phaseNumberOptions: [DD_DEFAULT, ONE_PHASE, TWO_PHASE, TREE_PHASE],
	mountTypeOptions: [DD_DEFAULT, FLOUR, STAND]
}

const defaultContacts = {
	FIO: '',
	phone: '',
	email: '',
	name: '',
	address: ''
}

function IbpConfigurator() {

	const [itemInfo, setItemInfo] = useState({})
	const [specList, setSpecList] = useState([])
	const [mainState, setMainState] = useState({
		...tabState,
		...defaultIbpState,
		...defaultIbpOptionsState
	})
	const [sum, setSum] = useState(0)
	const [itemList, setItemList] = useState([])
	const [dbList, setDBList] = useState({})
	const [itemsTableSizes, setSizes] = useState(IBP_SIZE)

	const [showNAWarn, setNAWarn] = useState(false)

	const [warnText, setWarnText] = useState('')
	const [showWarningFlag, setShowWarning] = useState(false)
	const [openModal, setOpenModal] = useState(false)

	const [locale, setLocale] = useState('ru')
	const [showPowerWarn, setPowerWarn] = useState(false)

	const [contacts, setContacts] = useState({...defaultContacts})
	React.useEffect(() => {
		loadDb()
	},[]);

	React.useEffect(() => {
		setSum(specList.map(item => item.sum).reduce((previousValue, currentValue) => {
			return Number(previousValue) + (isNaN(currentValue) ? 0 : Number(currentValue))
		}, 0).toFixed(2))

		setNAWarn(!!specList.filter(item => item.sum === 'N/A').length)

	},[specList]);


	// ++ Логика
	const loadDb = () => {
		jQuery.getJSON(
			'itkcfg.php',
			{
				type: 'ibp',
				action: 'get'
			},
			db => {
				setList(db.list)
			}
		);
	}

	const setList = (list) => {
		const newArr = list.reduce((counter, item) => {
			switch (item.type) {
				case 'ibp': counter.ibpList.push(item); break;
				case 'akb': counter.akbList.push(item); break;
				case 'snmp': counter.snmpList.push(item); break;
			}
			return counter
		}, {
			ibpList:[],
			akbList:[],
			snmpList:[]
		})
		setDBList(newArr)
		setItemList(newArr.ibpList)
		setOptions(newArr.ibpList)
	}

	const filterItemList = (type, value) => {

		let list = dbList.ibpList
		let snmpList = dbList.snmpList
		let akbList = dbList.akbList

		const minPower = type === 'minPower' ? value : Number(mainState.minPower)
		const maxPower = type === 'maxPower' ? value : Number(mainState.maxPower)

		const phaseNumber = type === 'phaseNumber' ? value : mainState.phaseNumber
		const mountType = type === 'mountType' ? value : mainState.mountType

		const double = type === 'double' ? value : mainState.double
		const line = type === 'line' ? value : mainState.line

		const moduleVal = type === 'module' ? value : mainState.module
		const transformVal = type === 'transform' ? value : mainState.transform
		const snmpVal = type === 'snmp' ? value : mainState.snmp
		const akbPres = type === 'akbPres' ? value : mainState.akbPres
		const useTime = type === 'useTime' ? value : mainState.useTime

		list = list.filter(({ akb_press }) => akbPres ? akb_press === 'да' : true)
		if( phaseNumber !== DD_DEFAULT) {
			list = list.filter(({ phase_num }) => {
				switch (phaseNumber){
					case ONE_PHASE: return phase_num === '1'
					case TWO_PHASE: return phase_num === '2'
					case TREE_PHASE: return phase_num === '3'
					default: return false
				}
			})
		}

		if( mountType !== DD_DEFAULT) {
			list = list.filter(({ mount_type }) => capitalizeFirstLetter(mount_type) === mountType)
		}

		list = list.filter( ({ ibp_type }) => double && ibp_type === 'online' || line && ibp_type === 'interract')
		list = list.filter(({ module }) => moduleVal ? module === 'да' : module === 'нет')

		const regexOM = moduleVal ? /OM/ : /^(?!.*OM)/
		akbList = akbList.filter(({ article }) => regexOM.test(article))

		const regexUseTime = useTime ? /OR/ : /^(?!.*OR)/
		akbList = akbList.filter(({ article }) => regexUseTime.test(article))

		if (snmpVal) {
			const regexSnmpMyPower = /^M.*-S$|^M.*-S-/
			const regexSnmpElectra = /^E/
			list = list.filter(({ article, ibp_type }) => regexSnmpMyPower.test(article)
				|| (regexSnmpElectra.test(article) && ibp_type === 'online'))
			list = [...list, ...snmpList]
		}
		if (transformVal) {
			const regexT = /-T$|.*-T-.*/;
			list = list.filter(({ article }) => regexT.test(article))
		}
		list = [...list, ...akbList]
		if (minPower) {
			list = list.filter(({ power }) => !power || Number(power) >= minPower * 1.2)
		}
		if (maxPower) {
			list = list.filter(({ power }) => !power || Number(power) <= maxPower * 1.2)
		}
		setItemList(list)
		setOptions(list, value, type)

	}

	const setOptions = (list, value = null, type = '') => {
		const phaseNumber = type === 'phaseNumber' ? value : mainState.phaseNumber
		const mountType = type === 'mountType' ? value : mainState.mountType

		let phaseNumberOptions = mainState.phaseNumberOptions
		let mountTypeOptions = mainState.mountTypeOptions

		if (phaseNumber === DD_DEFAULT){
			phaseNumberOptions =  delDuplicatesFromArray(list.map(({ phase_num }) => {
				let phaseOptionName = ''
				switch (phase_num){
					case '1': phaseOptionName = ONE_PHASE; break;
					case '2': phaseOptionName = TWO_PHASE; break;
					case '3': phaseOptionName = TREE_PHASE; break;
					default: phaseOptionName = null; break;
				}
				return phaseOptionName
			}).filter(Boolean))
			phaseNumberOptions.unshift(DD_DEFAULT)
			setState('phaseNumberOptions', phaseNumberOptions)
		}

		if (mountType === DD_DEFAULT){
			mountTypeOptions = delDuplicatesFromArray(list.map(({ mount_type }) => {
				return mount_type ? capitalizeFirstLetter(mount_type) : null
			}).filter(Boolean))
			mountTypeOptions.unshift(DD_DEFAULT)
			setState('mountTypeOptions', mountTypeOptions)
		}
	}

	const showWarning = (text) => {
		setWarnText(text)
		setShowWarning(true)
	}

	const clickAwayHandler = () => {
		closeWarn()
	}

	const closeWarn = () => {
		setShowWarning(false)
	}

	const reportBtnClickHandler = (type) => {
		let _params = {}
		switch (type) {
			case 'pdf':
				_params = {format: 'pdf'};
				_params.data = {
					specList: JSON.stringify(specList),
					showWarning: mainState.changeWarning
				};
				break;
			case 'excel':
				_params = {format: 'xls'};
				_params.data = {
					specList: JSON.stringify(specList),
					showWarning: mainState.changeWarning
				};
				break;
			case 'print':
				_params = {
					data: {
						specList: JSON.stringify(specList),
						showWarning: mainState.changeWarning
					}
				}
				break;
		}
		doPrint(_params)
	}

	const doPrint = (params) => {
		const _params = params || {};
		const $postForm = jQuery('<form action="print.php" method="post" target="_blank" accept-charset="UTF-8" />');

		const addHiddenField = function (name, value) {
			jQuery('<input type="hidden" />').attr('name', name).val(value).appendTo($postForm);
		};

		addHiddenField('type', 'ibp');

		if (_params.data) {
			Object.keys(_params.data).forEach(dataItemName => {
				addHiddenField(dataItemName, _params.data[dataItemName]);
			});
		}

		if (_params.format) {
			addHiddenField('format', _params.format);
		}

		if (locale) {
			addHiddenField('locale', locale);
		}

		$postForm.appendTo('body').submit().remove();
	}

	const onDataChange = (value, mark) => {
		if (mark === 'phone') {
			const formattedPhoneNumber = formatPhoneNumber(value);
			setContacts((prevState) =>({...prevState, [mark]:formattedPhoneNumber}))
			return
		}
		setContacts((prevState) =>({...prevState, [mark]:value}))
	}

	const formatPhoneNumber = (input) => {
		const phoneNumber = input.replace(/\D/g, '');

		return phoneNumber.replace(/(\d{1,3})(\d{1,3})?(\d{1,4})?(\d{0,2})?/, (match, p1, p2, p3, p4) => {
			let result = '';
			if (p1) result += `+7 (${p1}`;
			if (p2) result += `) ${p2}`;
			if (p3) result += `-${p3}`;
			if (p4) result += `-${p4}`;
			return result;
		});
	}

	const sendToEmail = () => {
		if (contacts.FIO.length === 0 || contacts.phone.length === 0 || contacts.email.length === 0 || contacts.name.length === 0 || contacts.address.length === 0) {
			showWarning('Для продолжения заполните свои контактные данные.')
		} else if (!contacts.email.includes('@')) {
			showWarning('Поле \'email\' должно содержать символ \'@\'')
		} else {
			jQuery.post(
				'itkcfg.php',
				{
					type: 'corridor',
					action: 'postForm',
					data: {
						mainState: mainState,
						contacts: contacts
					}
				}
			);
		}
	}

	const doAddToCart = (items) => {
		const goods = JSON.stringify(
			{
				products: items.map(i => (
					{
						cnt: i.count || 1,
						art: i.article || i.art,
						name: i.name,
					}
				))
			}
		)
		// Отправка JSON в ipro
		window.top.postMessage(goods, '*')
	}

	// -- Логика


	// ++ Отрисовака

	const ibpFilterBlock = () => {
		const elements = []

		elements.push(<div key={'ibpFilter' + elements.length} className={styles.sectionHeader}
											 style={{top: '20px', left: '20px'}}>Мощность нагрузки:</div>)

		elements.push(<div key={'ibpFilter' + elements.length} className={styles.inputHeader}
											 style={{top: '23px', left: '200px'}}>от</div>)

		elements.push(<Input
			key={'ibpFilter' + elements.length}
			x={220}
			y={20}
			width={55}
			type={'text'}
			dangerFlag={showPowerWarn}
			onChange={onMinPowerChange}
			onBlur={onMinPowerBlur}
			value={mainState.minPower}
		/>)

		elements.push(<div key={'ibpFilter' + elements.length} className={styles.inputHeader}
											 style={{top: '23px', left: '280px'}}>до</div>)

		elements.push(<Input
			key={'ibpFilter' + elements.length}
			x={300}
			y={20}
			width={55}
			type = 'text'
			onChange={onMaxPowerChange}
			dangerFlag={showPowerWarn}
			onBlur={onMaxPowerBlur}
			value={mainState.maxPower}
		/>)

		elements.push(<div key={'ibpFilter' + elements.length} className={styles.inputHeader}
											 style={{top: '23px', left: '360px'}}>Вт</div>)


		if (showPowerWarn) {
			elements.push(<div key={'ibpFilter' + elements.length} className={styles.powerMismatch}
												 style={{top: '50px', left: '265px'}}>Минимальное значение мощности должно быть меньше или равно максимальному</div>)
		}

		elements.push(<DropDown
			x={20}
			y={55}
			width={100}
			title='Число фаз:'
			key={'ibpFilter' + elements.length}
			onChange={onPhaseNumberHandler}
			value={mainState.phaseNumber}
			options={mainState.phaseNumberOptions}
		/>)

		elements.push(<DropDown
			x={150}
			y={55}
			width={100}
			title='Тип установки:'
			key={'ibpFilter' + elements.length}
			onChange={onMountTypeHandler}
			value={mainState.mountType}
			options={mainState.mountTypeOptions}
		/>)

		elements.push(<div key={'ibpFilter' + elements.length} className={styles.sectionHeader}
											 style={{top: '115px', left: '20px'}}>Тип ИБП:</div>)

		elements.push(<CheckBoxWithHeader
				x={20}
				y={140}
				labelX={50}
				labelY={145}
				title='Двойное преобразование (online)'
				key={'ibpFilter' + elements.length}
				onChange={onDoubleHandler}
				value={mainState.double}
				type='double'
			/>
		)

		elements.push(<CheckBoxWithHeader
				x={255}
				y={140}
				labelX={285}
				labelY={145}
				title='Модульный'
				key={'ibpFilter' + elements.length}
				onChange={onModuleHandler}
				value={mainState.module}
				type='module'
			/>
		)

		elements.push(<CheckBoxWithHeader
				x={20}
				y={165}
				labelX={50}
				labelY={170}
				title='Линейно-интерактивный'
				key={'ibpFilter' + elements.length}
				onChange={onLineHandler}
				value={mainState.line}
				type='line'
			/>
		)

		elements.push(<CheckBoxWithHeader
				x={255}
				y={165}
				labelX={285}
				labelY={170}
				title='С трансформатором'
				key={'ibpFilter' + elements.length}
				onChange={onTransformHandler}
				value={mainState.transform}
				type='transform'
			/>
		)

		elements.push(<CheckBoxWithHeader
				x={20}
				y={200}
				labelX={50}
				labelY={205}
				title='Наличие встроенного АКБ'
				key={'ibpFilter' + elements.length}
				onChange={onAkbPresHandler}
				value={mainState.akbPres}
				type='akbPres'
			/>
		)

		elements.push(<CheckBoxWithHeader
				x={255}
				y={200}
				labelX={285}
				labelY={205}
				title='SNMP карта'
				key={'ibpFilter' + elements.length}
				onChange={onSnmpHandler}
				value={mainState.snmp}
				type='snmp'
			/>
		)

		elements.push(<CheckBoxWithHeader
				x={20}
				y={240}
				labelX={50}
				labelY={240}
				widthLbl={110}
				title='Задать время автономной работы'
				key={'ibpFilter' + elements.length}
				onChange={onUseTimeHandler}
				value={mainState.useTime}
				type='useTime'
			/>
		)

		elements.push(<Input
			key={'ibpFilter' + elements.length}
			x={220}
			y={235}
			width={100}
			title={'Время автоновной работы, мин:'}
			type = 'text'
			onChange={onTimeHandler}
			onBlur={onTimeBlur}
			value={mainState.time}
			disabled={!(mainState.useTime)}
		/>)

		elements.push(<button
			key={'ibpFilter' + elements.length}
			onClick={toggleModalForm}
			className={styles.selectHelpBtn}
		>
			Помощь в подборе
		</button>)

		return elements
	}

	const getCustomButtons = () => {
		let elements = [];

		elements.push(
			<Button
				x="980"
				y="690"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.pdfBtnIcon}
				text="Сохранить в PDF"
				onClick={onBtnPrintPdfClick}
				key="printpdf"
			/>
		);

		elements.push(
			<Button
				x="1185"
				y="690"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.excelBtnIcon}
				text="Сохранить в Excel"
				onClick={onBtnExcelClick}
				key="excel"
			/>
		);

		elements.push(
			<Button
				x="980"
				y="735"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.printBtnIcon}
				text="Распечатать"
				onClick={onBtnPrintClick}
				key="print"
			/>
		);

		return elements
	}
	// -- Отрисовака

	// ++ Обработка событий

	const setState = (paramName, value) => {
		setMainState((prevState) =>({...prevState, [paramName]:value}))
	}

	// ++ Табы

	const ibpTabClick = () => {
		setState('tabType', IBP_TYPE_STYLE)
	}

	// -- Табы

	// ++ Инпуты

	const onMinPowerChange = (event) => {
		const value = event.target.value
		const regex = /^[0-9]+$/
		setState('minPower', regex.test(value) ? value : '')
		setPowerWarn(false)
	}
	const onMinPowerBlur = (event) => {
		const value = event.target.value
		const regex = /^[0-9]+$/
		if (Number(value) > Number(mainState.maxPower) && mainState.maxPower) {
			setPowerWarn(true)
			setItemList([])
			setState('minPower', regex.test(value) ? value : '')
			return
		}
		filterItemList('minPower', Number(value))
		setState('minPower', value)
	}

	const onMaxPowerChange = (event) => {
		const value = event.target.value
		const regex = /^[0-9]+$/
		setState('maxPower', regex.test(value) ? value : '')
		setPowerWarn(false)
	}
	const onMaxPowerBlur = (event) => {
		const value = event.target.value
		const regex = /^[0-9]+$/
		if (mainState.minPower && value && Number(value) < Number(mainState.minPower)) {
			setPowerWarn(true)
			setItemList([])
			setState('maxPower', regex.test(value) ? value : '')
			return
		}
		filterItemList('maxPower', Number(value))
		setState('maxPower', value)
	}
	const onTimeHandler = (event) => {
		const value = event.target.value
		const regex = /^[0-9]+$/
		setState('time', regex.test(value) ? value : '')
	}

	const onTimeBlur = (event) => {
		setState('time', Number(event.target.value))
	}

	// -- Инпуты

	// ++ Дропдауны

	const onPhaseNumberHandler = (event) => {
		const value = event.target.value
		filterItemList('phaseNumber', value)
		setState('phaseNumber', value)
	}

	const onMountTypeHandler = (event) => {
		const value = event.target.value
		filterItemList('mountType', value)
		setState('mountType', value)
	}
	// -- Дропдауны

	// ++ Чекбокс

	const onDoubleHandler = (event) => {
		const checked = event.target.checked
		filterItemList('double', checked)
		setState('double', checked)
	}
	const onLineHandler = (event) => {
		const checked = event.target.checked
		filterItemList('line', checked)
		setState('line', checked)
	}

	const onTransformHandler = (event) => {
		const checked = event.target.checked
		filterItemList('transform', checked)
		setState('transform', checked)
	}
	const onAkbPresHandler = (event) => {
		const checked = event.target.checked
		filterItemList('akbPres', checked)
		setState('akbPres', checked)
	}

	const onUseTimeHandler = (event) => {
		const checked = event.target.checked
		filterItemList('useTime', checked)
		setState('useTime', checked)
	}
	const onSnmpHandler = (event) => {
		const checked = event.target.checked
		filterItemList('snmp', checked)
		setState('snmp', checked)
	}
	const onModuleHandler = (event) => {
		const checked = event.target.checked
		filterItemList('module', checked)
		setState('module', checked)
	}

	// -- Чекбокс

	// ++ Кнопки

	const toggleModalForm = () => {
		setOpenModal(!openModal)
		if (!openModal) {
			setContacts({...defaultContacts})
		}
	}

	const onBtnPrintPdfClick = () => {
		if(!specList.length) {
			showWarning('Перед формированием отчета необходимо сформировать спецификацию')
			return
		}
		reportBtnClickHandler('pdf')
	}
	const onBtnPrintClick = () => {
		if(!specList.length) {
			showWarning('Перед формированием отчета необходимо сформировать спецификацию')
			return
		}
		reportBtnClickHandler('print')
	}
	const onBtnExcelClick = () => {
		if(!specList.length) {
			showWarning('Перед формированием отчета необходимо сформировать спецификацию')
			return
		}
		reportBtnClickHandler('excel')
	}
	// -- Кнопки

	// -- Обработка событий

	// ++ Для таблицы
	const onListItemCheck = (item) => {
		jQuery.getJSON(
			'itkcfg.php',
			{
				type: 'ibp',
				action: 'getItemNSI',
				article: item.article
			},
			itemInfoFromServ => {
				setItemInfo(itemInfoFromServ)
			}
		)
	}

	const onDelete = (item) => {
		setSpecList(prevState => {
			const newArr = [...prevState].filter(listItem => listItem.article !== item.article)
			doAddToCart(newArr)
			return newArr
		})
	}

	const onChangeQuantity = (item, value) => {
		setSpecList(prevState => {
			 const newArr = [...prevState].map(dataItem => {
				if(dataItem.article === item.article){
					dataItem = {
						...dataItem,
						count: value,
						sum: isNaN(dataItem.price) ? 'N/A' : dataItem.price * value
					}
				}
				return dataItem
			})
			doAddToCart(newArr)
			return newArr
		})

	}

	// Добавить элемент в корзину
	const addBasket = (item) => {
		jQuery.getJSON(
			'itkcfg.php',
			{
				type: 'ibp',
				action: 'getItemPriceNSI',
				article: item.article,
				groupId: '20'
			},	result => {
				const newItem = result.length ? result[0] : item

				let price = newItem.price ? newItem.price : 'N/A'

				setSpecList((prevState) => {
					const newArr = [...prevState]
					if(newArr.some(i => i.article === item.article)) {
						newArr.map(i => {
							if(i.article === item.article) {
								i.count = Number(i.count) + 1
								i.sum = isNaN(i.price) ? 'N/A' : (i.price*i.count).toFixed(2)
							}
							return i
						})
					} else {
						item.count = 1
						item.sum = isNaN(price) ? 'N/A' : (item.count * price).toFixed(2)
						item = {...item, price}
						newArr.push(item)
					}
					doAddToCart(newArr)
					return newArr
				})
			})
	}

// -- Для таблицы


	let firstLabelStyle = mainState.tabType === IBP_TYPE_STYLE ? '#fff' : '#E6EFF1'

	return (
		<div className={styles.cfg}>
			{/*Хэдер*/}
			<div>
				{/*Белый фон и лого*/}
				<div className={styles.logoBg}/>
				<Image
					className={styles.logo}
					blockChangeScale={true}
				/>
				{/*Оранжевый фон заголовка*/}
				<div className={styles.titleWrapper}>
					<div className={styles.title}>Подбор источника бесперебойного питания</div>
				</div>
			</div>

			{/*Левая часть*/}
			<div>
				<div style={{position: 'absolute', top: '100px', left: '20px'}}>
					<div
						onClick={ibpTabClick}
						style={{background: firstLabelStyle}}
						className={styles.ibpSectionTitle + ' ' + 'activeTab'}
					>
						<span>ИБП</span>
					</div>
				</div>
				<div>
					{mainState.tabType
						?
						<React.Fragment>
							<div className={styles.ibpFilterWrapper}>
								{ibpFilterBlock()}
							</div>
							{/*Спецификация*/}
							<Table
								title='Аксессуары'
								type='NoBucket'
								items={itemList}
								styles={{width: '440px', height: itemsTableSizes.height, top: itemsTableSizes.top, left: '20px', fontSize: '12px'}}
								onSelect={onListItemCheck}
								addBasket={addBasket}
								itemInfo={itemInfo}
								color='#76d750'
								configType='ibp'
							/>
						</React.Fragment>
						: null
					}
				</div>
			</div>

			{/*Кнопки*/}
			{getCustomButtons()}


			{/*Предупреждение*/}
			{
				showWarningFlag
					? <Popup
						warningText={warnText}
						type={'itk'}
						onClick={clickAwayHandler}
					/>
					: null
			}

			{openModal &&
				<Modal
					sendToEmail={sendToEmail}
					toggleModal={toggleModalForm}
					onChange={onDataChange}
					filterData={mainState}
				/>}


			{/*Центр*/}
			<div>
				<Table
					title='Корзина'
					type='Bucket'
					items={specList}
					styles={{width: '480px', height: '525px', top: '100px', left: '480px', fontSize: '12px'}}
					onSelect={onListItemCheck}
					onDelete={onDelete}
					onChangeQuantity={onChangeQuantity}
					color='#76d750'
					configType='ibp'
				/>
				<div className={styles.sum}>Сумма: {sum} руб. Расчитанная сумма является предварительной. Конечную сумму уточняйте при заказе.</div>
				{ showNAWarn ? <div className={styles.naPrice}>N/A - Цена не определена. Не входит в общую сумму.</div> : null }
			</div>

			{/*Правая часть*/}
			<div>
				{/* Артикул и имя */}
				<div className={styles.itemInfoBG}/>
				{itemInfo && itemInfo[0] ? (
					<a href={`https://qr.iek.group/${itemInfo && itemInfo[0] && itemInfo[0].art}`}
						 target="_blank">
						<div className={styles.itemInfo}>
							<div className={styles.itemInfo_Article}>{itemInfo && itemInfo[0] && itemInfo[0].art}</div>
							<div>{itemInfo && itemInfo[0] && itemInfo[0].name}</div>
						</div>
					</a>
				) : (
					<div className={styles.itemInfoNoArticle}/>
				)}

				{/* Фото */}
				<Image
					className={styles.itemImg + ' ' +
						(itemInfo && itemInfo.length === 0 ? styles.warn : '')}
					url={itemInfo && itemInfo[0] && itemInfo[0].ImgPng && itemInfo[0].ImgPng[0].file_ref.uri ? itemInfo[0].ImgPng[0].file_ref.uri : null}
				/>


				{/* Преимущества */}
				<div className={styles.descriptionWrapper} />
				{itemInfo && itemInfo[0] && itemInfo[0].Advantages[0].desc ? (
					<div className={styles.description}>
						{itemInfo[0].Advantages[0].desc}
					</div>
				) : itemInfo && itemInfo.length === 0 ? (
						<div className={styles.description}>
							На сайте временно веутся технические работы. Некоторые данные могут быть недоступны
						</div>
					)
					: (
						<div className={styles.descriptionEmpty}>
						</div>
					)}
			</div>

			{/*Футер*/}
			<div>
				{/* Техническая поддержка */}
				<div className={styles.footerMainBg} />
				<div className={styles.techSupport} >
					Техническая поддержка:
				</div>
				<span className={styles.phoneNumber}>+7 (495) 542-22-27</span>

				{/* На основной сайт IEK */}
				<div className={styles.footerAddBg}/>
				<a  className={styles.homeLink} href={'https://www.itk-group.ru/'} target="_blank">На основной сайт ITK</a>
			</div>
		</div>
	)
}
export default IbpConfigurator



// WEBPACK FOOTER //
// ./src/react/IbpConfigurator.jsx